import {IOManager} from "../multigame/IO"

export class IOManagerService extends IOManager
{
}